import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Paper, Box, Typography, TextField, Button, Avatar } from '@material-ui/core'
import Breadcrumb from '../../Components/Breadcrumbs'
import { useStyles } from './style'
import GetAppIcon from '@material-ui/icons/GetApp'
import PublishIcon from '@material-ui/icons/Publish'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import { AppButton, Loader } from '../../Components'
import { OutlinedButton } from '../../elements'
import { useFormik } from 'formik'
import { useLocation } from 'react-router-dom'
import * as yup from 'yup'
import _ from 'lodash'
import { tagsService } from '../../Services/TagsService/TagsService'
import DisplayMessage from '../../Components/DisplayMessage'
import { COMMON } from '../../utils/constants'
import * as messageTypes from '../../utils/messageTypes'
import CustomDialog from '../../Components/CustomDialog'
import Icon from '../../utils/icons'
import { programService } from '../../Services'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'

const validationSchema = yup.object({
  name: yup.string('Enter tag name')
    .max(15, 'Tag name should be of maximum 15 characters')
    .matches(/([()_.\\s]*[A-Za-z0-9]+[A-Za-z0-9_.()\\s]*)/, 'Tag name not valid. Only letters, numbers and _,.,(,) allowed')
    .required('Tag name is required'),
})

function TagForm(props) {
  const classes = useStyles()
  const [tag, setTag] = useState(_.get(props, 'location.state.tag', ''))
  const [file, setFile] = useState('')
  const [open, setOpen] = useState()
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [deleteOpen, setDeleteOpen] = useState()
  const [loading, setLoading] = useState(false)
  const [tagFile, setTagFile] = useState([])
  const [program, setProgram] = useState({})
  const programId = props?.match?.params?.programId
  const location = useLocation()

  if (props.match && props.match.path && props.match.path.includes('edit-tag') && !tag) {
    props.history.push(`/programs/${programId}/tags-manager`)
  }

  const formik = useFormik({
    initialValues: {
      name: tag.name,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: props.currentUser.account_id, programID: programId })
      tag ? submitTag(values) : createTag(values)
    },
  })

  const getProgram = () => {
    const { currentUser } = props
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const createTag = (values) => {
    if (!values.name.match(/^(?!\s)[()_.\s]*[A-Za-z0-9]+[A-Za-z0-9_.()\s]*\S$/)) {
      values.name = values.name.trim()
    }
    const { currentUser } = props
    const method = tag ? 'put' : 'post'
    setLoading(true)
    tagsService.submitTag(currentUser.account_id, programId, values, method, tag)
      .then(tagData => {
        setLoading(false)
        setTag(values)
        setOpen(true)
        setMessage('Tag created successfully')
        setMessageType(messageTypes.SUCCESS)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const submitTag = (values) => {
    const { currentUser } = props
    const method = 'post'
    setLoading(true)
    if (tagFile) {
      setLoading(true)
      tagsService.submitTagFile(currentUser.account_id, programId, values, method, tagFile)
        .then(tagFileData => {
          setLoading(false)
          setOpen(true)
          setMessage(tag ? 'Tag updated successfully' : 'Tag created successfully')
          setMessageType(messageTypes.SUCCESS)
          setTimeout(() => {
            props.history.push({ pathname: `/programs/${programId}/tags-manager`, state: { programId: programId } })
          }, 2000)
        })
        .catch(error => {
          setLoading(false)
          setOpen(true)
          setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
          setMessageType(messageTypes.ERROR)
        })
    } else {
      setLoading(false)
      setTag(values)
      setOpen(true)
      setMessage('Please choose a valid file')
      setMessageType(messageTypes.INFO)
    }
  }

  const deleteTag = () => {
    const { currentUser } = props
    setLoading(true)
    const obj = { tag: tag.name, update_enrollment: true }
    if (!obj.tag.match(/^(?!\s)[()_.\s]*[A-Za-z0-9]+[A-Za-z0-9_.()\s]*\S$/)) {
      obj.tag = obj.tag.trim()
    }
    tagsService.deleteTag(currentUser.account_id, programId, obj)
      .then(tagData => {
        setLoading(false)
        setDeleteOpen(false)
        setOpen(true)
        setMessage('Tag deleted successfully')
        setMessageType(messageTypes.SUCCESS)
        setTimeout(() => {
          props.history.push({ pathname: `/programs/${programId}/tags-manager`, state: { programId: programId } })
        }, 2000)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getDeleteTagForm = () => {
    return (
      <>
        <Box display="flex" justifyContent="center" mt={1} mb={5}>
          <Typography className={classes.deleteModalText}>Are you sure you want to delete this tag?</Typography>
        </Box>
        <div className={classes.buttonContainer}>
          <AppButton className={classes.deleteButton} text="yes" onClick={deleteTag} />
          <AppButton className={classes.deleteButton} fill={false} text="no" onClick={() => setDeleteOpen(false)} />
        </div>
      </>
    )
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const getTagCsv = () => {
    const { currentUser } = props
    tagsService.getTagCsv(currentUser.account_id, programId, tag)
      .then(tagCsvData => {
        setFile(tagCsvData)
      })
      .catch(error => error)
  }

  const renderIcon = (errors, touched) => {
    return touched ? _.isUndefined(errors) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></>
  }

  useEffect(() => {
    if (Object.keys(program).length <= 0) {
      getProgram()
    }
  }, [programId])

  useEffect(() => {
    if (tag) {
      getTagCsv()
    }
  }, [tag])

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Tags Manager': `/programs/${program.id}/tags-manager` })
      value.push(location.pathname.includes('edit-tag') ? { 'Edit Tag': '' } : { 'Create a New Tag': '' })
    } else {
      value.push({ 'Tags Manager': '' })
      value.push(location.pathname.includes('edit-tag') ? { 'Edit Tag': '' } : { 'Create a New Tag': '' })
    }
    return value
  }

  return (
    <Box>
      <Breadcrumb value={getBreadcrumbs()} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>{location.pathname.includes('edit-tag') ? 'Edit Tag' : 'Create a New Tag'}</Typography>
        {tag && props.isAdmin ? <OutlinedButton label='delete tag' onClick={() => setDeleteOpen(true)} /> : ''}
      </Box>
      <Loader loading={loading} />
      <CustomDialog open={deleteOpen} fullWidth maxWidth="xs" title="" handleClose={() => setDeleteOpen(false)} content={getDeleteTagForm()} />
      <DisplayMessage
        open={open}
        message={message}
        messageType={messageType}
        handleClose={handleMessageClose}
      />
      <div className={classes.formCardWrapper}>
        <Paper className={classes.paper} elevation={2}>
          <form onSubmit={formik.handleSubmit}>
            <div className={classes.formTitle}>You can add tags for the systems in your program. You will be able to use these tags for building virtual power plants and scheduling events.</div>
            <TextField
              id="tag-name"
              name="name"
              className={classes.textInput}
              label="Tag Name"
              disabled={tag}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={(e) => formik.setFieldValue('name', e.target.value.trim())}
              InputProps={{
                endAdornment: renderIcon(formik.errors.name, formik.touched.name),
              }}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
            {tag ?
              <>
                <div className={classes.formTitle}>Please download the systems csv file below and update the tags with respect to the systems and upload it here.</div>

                <div className={classes.formContainer}>
                  <div className={classes.formPaper}>
                    <Avatar aria-label="recipe" className={classes.mb20}>
                      <GetAppIcon />
                    </Avatar>
                    <div className={classes.mb20}>Download</div>
                    <a href={`data:text/csv;charset=utf-8,${file}`} download="systems_template.csv" className={`${classes.mb10} ${classes.linkStyle}`}>Systems_Template.CSV</a>
                  </div>
                  <div className={classes.arrowContainer}>
                    <ArrowRightAltIcon color="primary" fontSize="large" /></div>
                  <div className={classes.formPaper}>
                    <Avatar aria-label="recipe" className={classes.mb20}>
                      <PublishIcon />
                    </Avatar>
                    <div className={classes.mb20}>Upload</div>
                    <input
                      accept=".csv"
                      className={classes.uploadInput}
                      id="tagFile"
                      name="tagFile"
                      type="file"
                      //value={tagFile}
                      onChange={(e) => {
                        setTagFile(e.target.files[0])
                      }}
                    // onChange={formik.handleChange}
                    />
                    <label htmlFor="tagFile">
                      <OutlinedButton label="Browse File" component="span" />
                    </label>
                    {tagFile ? <div className={classes.fileName}>{tagFile.name}</div> : ''}
                  </div>
                </div>
              </> : ''}
            <hr className={classes.hr} />
            <AppButton className={classes.floatR} type="submit" text={`${tag ? "Save" : "Create Tag"}`}></AppButton>
          </form>
        </Paper>
      </div>
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isAdmin } = auth
  return { currentUser, isAdmin }
}

export default connect(mapStateToProps, {})(TagForm)